import Base from "./Base";

export default class Auth extends Base {
    login = (username, password) => {
        return this.post('/users/auth/login', { email: username, password: password });
    }

    logout = () => (
        this.post('/users/auth/logout')
    )

    finalize = (data) => (
        this.post('/users/auth/register/finalize', data)
    )

    me = () => {
        return this.get('/users/me')
    }

    reset = (email) => (
        this.post('/users/auth/reset', { email: email })
    )

    finalizeReset = (data) => (
        this.post('/users/auth/reset/finalize', data)
    )

    refresh = (token) => (
        this.post('/users/auth/refresh', { token: token })
    )

    closeAccount = () => (
        this.delete('/users/me')
    )

    register = (data) => (
        this.post('/users/auth/register', data)
    )

    verify = (data) => (
        this.post('/users/auth/register/verify', data)
    )
}


// WEBPACK FOOTER //
// ./src/services/api/Auth.js